// Favourites: saved in the shopper's browser (localStorage) as a list of product handles.
(function () {
  var KEY = 'bg-favourites';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('favourites:change', { detail: { handles: list } }));
  }

  function updateButtons(root) {
    var list = read();
    (root || document).querySelectorAll('[data-favourite-handle]').forEach(function (button) {
      var saved = list.indexOf(button.dataset.favouriteHandle) > -1;
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.classList.toggle('is-saved', saved);
      var label = saved ? button.dataset.labelRemove : button.dataset.labelAdd;
      var current = button.getAttribute('aria-label') || '';
      var title = current.indexOf(': ') > -1 ? current.slice(current.indexOf(': ') + 2) : '';
      button.setAttribute('aria-label', title ? label + ': ' + title : label);
      var text = button.querySelector('.favourite-toggle__text');
      if (text) text.textContent = label;
    });
  }

  function updateCount() {
    var count = read().length;
    document.querySelectorAll('[data-favourites-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refresh(root) {
    updateButtons(root);
    updateCount();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-favourite-handle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = button.dataset.favouriteHandle;
    var list = read();
    var index = list.indexOf(handle);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.unshift(handle);
      button.classList.add('is-popping');
      setTimeout(function () {
        button.classList.remove('is-popping');
      }, 400);
    }
    write(list);
  }, true);

  document.addEventListener('favourites:change', function () {
    refresh();
  });

  // Keep tabs in sync and pick up hearts added later (quick add pop-up, related products, section reloads).
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) refresh();
  });
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        updateButtons();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.BrightFavourites = { read: read, write: write, refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      refresh();
    });
  } else {
    refresh();
  }
})();
